import { Button, Box } from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const expandButtonStyle = {
  width: "auto",
  height: "25px",
  ".MuiButton-startIcon": {
    margin: 0,
  },
};

const ExpandButtonGroup = ({ row, selectedTable, setSelectedTable, buttons }) => {
  return (
    <Box sx={{display:'flex',flexDirection:'column',alignItems:'flex-start'}} ml={10}>
      {buttons.map(({ key, label }) => (
        <Button
          key={key}
          size="small"
          variant="contained"
          startIcon={
            selectedTable === key && row.getIsExpanded() ? (
              <ExpandMoreIcon />
            ) : (
              <ExpandLessIcon />
            )
          }
          sx={{ ...expandButtonStyle, mb: .35 }}
          onClick={() => setSelectedTable(key)}
        >
          {label}
        </Button>
      ))}
    </Box>
  );
};

export default ExpandButtonGroup;
